import { Navigate } from "react-router-dom";
import { useAuthStore } from "../state/authStore";
import TeamOnboardingGate from "./TeamOnboardingGate";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading, deletedUntil } = useAuthStore();

  if (loading) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
        <div className="spinner" style={{ width: 32, height: 32 }} />
      </div>
    );
  }

  if (!user) {
    // #398: an account just scheduled for deletion goes to sign-in with no returnTo,
    // so restoring it later doesn't send the person back to the delete form.
    if (deletedUntil) return <Navigate to="/login" replace />;
    const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }

  return <TeamOnboardingGate>{children}</TeamOnboardingGate>;
}
